import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-dialog-check',
  templateUrl: './dialog-check.component.html',
  styleUrls: ['./dialog-check.component.css']
})
export class DialogCheckComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
